import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import MenuItem from "@mui/material/MenuItem";

function Border({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"default"} value={"Default"}>
          Default
        </MenuItem>,
        <MenuItem key={"initial"} value={"none"}>
          No borders
        </MenuItem>,
        <MenuItem key={"solid"} value={"solid"}>
          Solid
        </MenuItem>,
      ]}
      rules={{ required }}
    />
  );
}

export const JSBorderComponent: JSInputComponent = {
  Component: Border,
  handlesCssProperties: ["border", "borderTop", "borderBottom", "borderRight", "borderLeft"],
};
